import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Spin, Table } from "antd";

import * as XLSX from "xlsx";

import productApi from "../../../../apis/Product.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const BrandExcelUpload = ({
  setBrandModalShow,
  handleInitialBtnClick,
  sellerList,
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [uploadExcelData, setUploadExcelData] = useState([]);
  const [uploadExcelName, setUploadExcelName] = useState("");

  const sellerColumns = [
    {
      title: "아이디",
      dataIndex: "seller_id",
      key: "seller_id",
      width: 70,
    },
    {
      title: "판매자명",
      dataIndex: "seller_name",
      key: "seller_name",
    },
    {
      title: "대표자",
      dataIndex: "representative",
      key: "representative",
    },
    {
      title: "이메일",
      dataIndex: "email",
      key: "email",
      render: (value) => {
        if (value) {
          return value;
        } else {
          return "-";
        }
      },
    },
  ];
  const columns = [
    {
      title: "판매자명",
      dataIndex: "seller_name",
      key: "seller_name",
      // ellipsis: true,
    },
    {
      title: "브랜드명",
      dataIndex: "brand_name",
      key: "brand_name",
      // ellipsis: true,
    },
    {
      title: "구분",
      dataIndex: "",
      key: "",
      width: 60,
      align: "center",
      // ellipsis: true,
      render: (_, record) => {
        if (record?.seller_id) {
          return "브랜드";
        } else {
          return "판매자/\n브랜드";
        }
      },
    },
    {
      title: "비고",
      dataIndex: "",
      key: "",
      width: 300,
      render: (_, record) => {
        let text = null;
        if (record?.nonNumberList) {
          text = `${record?.nonNumberList.join(
            ", ",
          )} 값은 숫자 형식이 아닙니다.`;
        }
        if (record?.nonValueList) {
          if (text) {
            text += `\n${record?.nonValueList.join(
              ", ",
            )} 항목에 값이 없습니다.`;
          } else {
            text = `${record?.nonValueList.join(", ")} 항목에 값이 없습니다.`;
          }
        }
        if (record?.alertList) {
          if (text) {
            text += `\n${record?.alertList.join("\n")}`;
          } else {
            text = record?.alertList.join("\n");
          }
        }
        return <span style={{ whiteSpace: "pre-line" }}>{text}</span>;
      },
    },
  ];
  /**
   * 업로드된 엑셀 읽기
   * ExcelData, ExcelName 저장
   */
  const readExcelData = (e) => {
    setIsLoading(true);
    if (e.target.value !== "") {
      setLoadingStatus(true);
      let reader = new FileReader();
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, {
          type: "binary",
          cellDates: true,
          dateNF: "YYYY-MM-DD",
        });
        const sheetNameList = wb.SheetNames;
        const firstSheet = wb.Sheets[sheetNameList[0]];

        let data = XLSX.utils.sheet_to_json(firstSheet, { raw: false });
        const keyValue = data.shift();

        let list = [];
        for (let i = 0; i < data?.length; i++) {
          const row = data[i];
          let param = {
            unique_id: i,
          };
          for (const rowKey in row) {
            switch (rowKey) {
              case "판매자 아이디":
              case "배송비":
              case "무료배송조건":
              case "지역별 차등 배송비":
              case "프로모션 기본 수수료율":
                // 해당 항목들에 값이 있는 경우
                if (row[rowKey]) {
                  // 값이 숫자 형식이 아닌 경우, 숫자 형식이 아님을 안내
                  if (isNaN(Number(row[rowKey]))) {
                    setListForParam("nonNumberList", rowKey, param);
                  } else if (
                    rowKey === "프로모션 기본 수수료율" &&
                    Number(row[rowKey]) >= 100
                  ) {
                    // "프로모션 기본 수수료율" 항목의 값이 100 이상인 경우, 수수료율은 100 이상일 수 없음 안내
                    setListForParam(
                      "alertList",
                      `${rowKey} 항목의 값은 100을 넘을 수 없습니다.`,
                      param,
                    );
                  }
                  param[`${keyValue[rowKey]}`] = Number(row[rowKey]);
                } else if (rowKey !== "판매자 아이디") {
                  // 해당 항목들 중 "판매자 아이디" 항목 제외 값이 없는 경우 기본값 0 셋팅
                  param[`${keyValue[rowKey]}`] = 0;
                }
                break;
              case "부가세 포함 여부":
                // 값이 있으면서 "TRUE" || "true" 인 경우 처리
                if (
                  row[rowKey] &&
                  (row[rowKey] === "TRUE" || row[rowKey] === "true")
                ) {
                  param[`${keyValue[rowKey]}`] = true;
                } else {
                  param[`${keyValue[rowKey]}`] = false;
                }
                break;
              default:
                param[`${keyValue[rowKey]}`] = row[rowKey];
            }
          }
          if (Object.keys(param)?.includes("seller_id")) {
            // 기존 판매자 계정에 브랜드 추가
            const findIdx = sellerList?.findIndex(
              (seller) =>
                seller.seller_id === param["seller_id"] &&
                seller.seller_name === param["seller_name"],
            );
            if (findIdx <= -1) {
              setListForParam(
                "alertList",
                "유효하지 않은 판매자 정보입니다.",
                param,
              );
            }
          } else {
            // 새로운 판매자 계정 생성
            checkParamForNewSeller(param);
          }
          list.push(param);
        }
        setUploadExcelData(list);
        setUploadExcelName(e.target.files[0]?.name);
      };
      reader.readAsBinaryString(e.target.files[0]);
      setLoadingStatus(false);
    } else {
      setUploadExcelData([]);
      setUploadExcelName("");
    }
    setIsLoading(false);
  };

  /**
   * 엑셀 데이터 업로드
   */
  const handleExcelUpload = async () => {
    setIsLoading(true);
    try {
      const param = {
        brandList: uploadExcelData,
        created_by: user?.id === 724 ? 1 : user?.id,
      };
      const res = await productApi.createBrandListWithExcel(param);
      if (res.code === 200) {
        setIsLoading(false);
        setLoadingStatus(false);
        alert(
          `정상적으로 등록이 완료 되었습니다.${
            res.result?.message ? `\n${res.result?.message}` : ""
          }`,
        );
        handleInitialBtnClick();
        setBrandModalShow(false);
      } else {
        setIsLoading(false);
        setLoadingStatus(false);
        window.alert("오류가 발생했습니다. 관리자에게 문의하세요");
      }
    } catch (e) {
      setIsLoading(false);
      setLoadingStatus(false);
      console.log("[ProductBrandView] handleExcelUpload error = ", e);
    }
  };

  /**
   * 새로운 판매자 계정 생성시 필요한 데이터 밸리데이션
   */
  const checkParamForNewSeller = (param) => {
    const businessNumberReg = /^[0-9]{3}-[0-9]{2}-[0-9]{5}$/;
    const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;

    // 기존 판매자 계정과 동일한 이름이 있는지 확인
    if (param.representative && param.seller_name) {
      const findIdx = sellerList?.findIndex(
        (seller) =>
          seller.representative === param["representative"] &&
          seller.seller_name === param["seller_name"],
      );
      if (findIdx > -1) {
        setListForParam("alertList", "사업자번호", param);
      }
    } else if (!param.representative) {
      setListForParam("nonValueList", "대표자", param);
    } else {
      setListForParam("nonValueList", "상호(판매자명)", param);
    }
    // 사업자 번호 양식
    if (!param?.business_number) {
      setListForParam("nonValueList", "사업자번호", param);
    } else if (!businessNumberReg.test(param?.business_number)) {
      setListForParam(
        "alertList",
        "사업자번호 형식과 일치하지 않습니다.",
        param,
      );
    }
    // 통신판매업신고번호
    if (!param?.mail_order_sales_number) {
      setListForParam("nonValueList", "통신판매업신고", param);
    }
    // 연락처
    if (!param?.phone) {
      setListForParam("nonValueList", "연락처", param);
    }
    // 이메일
    if (!param?.email) {
      setListForParam("nonValueList", "이메일", param);
    } else if (!emailReg.test(param?.email)) {
      setListForParam("alertList", "이메일 형식과 일치하지 않습니다.", param);
    }
    // 영업소재지
    if (!param?.business_location) {
      setListForParam("nonValueList", "영업소재지", param);
    }
    // 교환/환불 시 보내실 곳
    if (!param?.shipment_place) {
      setListForParam("nonValueList", "교환/환불 시 보내실 곳", param);
    }
  };

  const setListForParam = (key, msg, param) => {
    if (param && Object.keys(param) && Object.keys(param)?.includes(key)) {
      let alertList = [...param[key]];
      alertList.push(msg);
      param[key] = alertList;
    } else {
      param[key] = [msg];
    }
  };

  /**
   * 엑셀 파일 업로드 > 등록하기 버튼 disabled 처리
   */
  const disabledSubmitBtn = () => {
    if (
      uploadExcelData &&
      uploadExcelData?.length &&
      uploadExcelData.every((data) => {
        const keyList = Object.keys(data);
        return (
          !keyList.includes("nonNumberList") &&
          !keyList.includes("nonValueList") &&
          !keyList.includes("alertList")
        );
      })
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className={`excel-body`}>
      {isLoading && loadingStatus && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            border: "solid 1px #ced4da",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "1em 1.5em",
            display: "flex",
            alignItems: "center",
            gap: "1em",
            boxShadow: "0 0px 6px 0 rgba(0, 0, 0, 0.16)",
            zIndex: 9,
          }}
        >
          <Spin style={{ lineHeight: 1 }} />
          <p style={{ margin: 0, whiteSpace: "pre-line" }}>
            브랜드 및 판매자 정보를 등록 중입니다{"\n"}
            <span
              style={{
                color: "#868e96",
              }}
            >
              * 절대 창을 닫지 마세요
            </span>
          </p>
        </div>
      )}
      <b>엑셀 파일을 업로드 하세요</b>
      <div className={`excel-file-upload-div`}>
        <div className={`excel-file-upload-each`}>
          <p className={`upload-title`}>파일 업로드</p>
        </div>
        <div className={`excel-file-upload-each`}>
          <div className={`upload-input`}>
            {uploadExcelName?.length ? uploadExcelName : "선택된 파일 없음"}
          </div>
          <Button
            className={`excel-file-select-btn`}
            onClick={() => {
              let excelInput = document.getElementById("excelFile");
              if (excelInput) {
                excelInput.click();
              }
            }}
            loading={isLoading}
          >
            파일 선택
          </Button>
          <Button
            className={`excel-file-upload-btn brand-excel`}
            onClick={handleExcelUpload}
            loading={isLoading}
            disabled={isLoading || disabledSubmitBtn()}
          >
            등록하기
          </Button>
        </div>
      </div>
      <input
        style={{ display: "none" }}
        type={"file"}
        id="excelFile"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={readExcelData}
      />
      <>
        <p className={`excel-description`}>
          * 기존 판매자 계정에 브랜드만 추가하는 경우, 아래 판매자 목록 중
          해당하는 판매자 정보의 <b>아이디와 판매자명</b>을 그대로 기입하여
          작성해주세요.
        </p>
        <p className={`excel-description`}>
          * 새로운 판매자 계정까지 추가하는 경우, 등록하려는 판매자 정보(
          <b>** 표시된 항목들</b>)를 꼼꼼하게 기입해주세요.
        </p>
        <p className={`excel-description`}>
          * 필수정보(<b>판매자명, 브랜드</b>
          )가 제대로 입력되었는지 확인해주세요.
        </p>
        <p className={`excel-description`}>
          * 파일 형식은 <b>XLSX</b>로 올려주세요.
        </p>
        <p className={`excel-description`}>
          * 브랜드 및 판매자 정보가 기재된 엑셀파일 선택 후 아래 표에서 비고란
          항목 확인 후 <b>등록하기</b>를 눌러 브랜드/판매자 추가를 완료하세요.
        </p>
        <Button
          className="excel-template-download"
          href={`${process.env.REACT_APP_HOST}/assets/files/Brand_Template.xlsx`}
        >
          <p className={`excel-description`}>엑셀 양식 다운로드</p>
        </Button>
        <Table
          className={`commission-table`}
          columns={uploadExcelData?.length ? columns : sellerColumns}
          dataSource={uploadExcelData?.length ? uploadExcelData : sellerList}
          loading={isLoading}
          bordered
          size="small"
          rowKey="unique_id"
          rowClassName="coupon-table-row"
          pagination={false}
          tableLayout={uploadExcelData?.length ? null : "auto"}
          scroll={{
            y: "25vh",
          }}
          style={{
            margin: "0.5em 0",
          }}
        />
      </>
    </div>
  );
};

export default BrandExcelUpload;
